<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form" v-if="!loading">
      <div class="empadronamiento__intro__main__form__header">
        <p>{{ ModelProcedure.UnitFullName }}</p>
      </div>
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-tittle">
              <p>¿HABRÁ OTROS RESIDENTES EN LA UNIDAD?</p>
              <small style="color:red; padding-left: 0px;">Recordá que la declaración de residentes es
                <span style="font-weight: bold;">OBLIGATORIA</span>
                .
              </small>
              <div class="demo" style="margin-top: 14px;">
                <input type="radio" :value="true" v-model="hasResident" />
                <label>SI</label>
              </div>
              <div class="demo">
                <input type="radio" :value="false" v-model="hasResident" />
                <label>NO</label>
              </div>
            </div>

            <template v-if="hasResident">
              <div class="empadronamiento__intro__main__form__container-header">
                <p>DATOS – RESIDENTES</p>
              </div>
              <p class="empadronamiento__form_header_info_text" style="text-align: justify">
                Por favor, ingresá los datos requeridos con la información de
                cada uno de los residentes. Para este paso es necesario contar
                con foto del DNI (frente y dorso).
              </p>
              <fieldset v-for="(_, idx) in ModelProcedure.Resident" :key="viewKey + '-' + idx">
                <div class="empadronamiento__intro__main__form__container-tittle flex-between">
                  <p style="text-transform: uppercase">
                    Residente {{ idx + 1 }} :
                  </p>
                  <p class="delete" v-if="idx > 0" @click="deleteResident(idx)">
                    Eliminar
                  </p>
                </div>
                <base-select placeholder="Tipo de documento *"
                  v-model="ModelProcedure.Resident[idx].IdentificationTypeId" :options="Enums.IdentificationType"
                  :invalid="$v.ModelProcedure.Resident.$each[idx].IdentificationTypeId
                    .$invalid && submitted
                    " @input="onDocTypeChange(idx)" />

                <base-input placeholder="Documento *"
                  :value="ModelProcedure.Resident[idx].Identification"
                  @input="val => { ModelProcedure.Resident[idx].Identification = normalizeResidentDoc(val, ModelProcedure.Resident[idx].IdentificationTypeId) }"
                  @blur="val => { ModelProcedure.Resident[idx].Identification = normalizeResidentDoc(val, ModelProcedure.Resident[idx].IdentificationTypeId); triggerResidentLookup(idx) }"
                  :invalid="($v.ModelProcedure.Resident.$each[idx].Identification.$invalid && submitted) || (submitted && !!docFormatErrorResident(ModelProcedure.Resident[idx].Identification, ModelProcedure.Resident[idx].IdentificationTypeId))" />
                <small v-if="submitted && docFormatErrorResident(ModelProcedure.Resident[idx].Identification, ModelProcedure.Resident[idx].IdentificationTypeId)" style="color: red;">
                  {{ docFormatErrorResident(ModelProcedure.Resident[idx].Identification, ModelProcedure.Resident[idx].IdentificationTypeId) }}
                </small>
                <small v-else-if="
                  $v.ModelProcedure.Resident.$each[idx].Identification
                    .$error &&
                  $v.ModelProcedure.Resident.$each[idx].Identification
                    .notDuplicate === false
                " style="color: red;">
                  Ese residente ya fue agregado
                </small>

                <base-input placeholder="Nombre *" v-model="ModelProcedure.Resident[idx].Name" :invalid="$v.ModelProcedure.Resident.$each[idx].Name.$invalid &&
                  submitted
                  " />
                <base-input placeholder="Apellido *" v-model="ModelProcedure.Resident[idx].LastName" :invalid="$v.ModelProcedure.Resident.$each[idx].LastName.$invalid &&
                  submitted
                  " />

                <base-date-picker v-model="ModelProcedure.Resident[idx].DateOfBirth" :label="'Fecha de nacimiento *'"
                  :maxDate="DateOfBirthMaxDate" @input="validateAge(ModelProcedure.Resident[idx].DateOfBirth)" :invalid="$v.ModelProcedure.Resident.$each[idx].DateOfBirth
                    .$invalid && submitted
                    " />

                <div class="empadronamiento__intro__main__form__container-tittle">
                  <p>Estado civil</p>

                  <div class="demo" v-for="marital in Enums.ProcedureTitularMaritalStatusType"
                    :key="viewKey + '-' + marital.Id">
                    <input type="radio" :value="marital.Id" @click="onCivilStatusClick(idx, marital.Id)" :checked="marital.Id ==
                      ModelProcedure.Resident[idx].MaritalStatusId
                      " />
                    <label>{{ marital.Name }}</label>
                  </div>
                  <div :style="{ 'min-height': '20px' }">
                    <small v-if="
                      ModelProcedure.Resident[idx].MaritalStatusId === 0 &&
                      submitted
                    " style="color: red;">Seleccione un estado civil</small>
                  </div>
                </div>

                <base-select placeholder="Relación *" v-model="ModelProcedure.Resident[idx].ResidentTypeId"
                  :options="Enums.ProcedureResidentType" :invalid="$v.ModelProcedure.Resident.$each[idx].ResidentTypeId
                    .$invalid && submitted
                    " />
                <div v-if="!hideAttachments(idx)">
                  <template v-for="(attach, i) in sortedResidentAttachTypes">
                    <base-file-upload
                      v-if="attach.Code !== 'ProcedureResidentAttachment.IdFacialRecognition' || ModelProcedure.FacialRecognition"

                      :key="viewKey + '-' + i" :keyIndex="idx" :attach="attach" :showTooltipActive="showTooltipActive"
                      @changeTooltipActive="showTooltipActive = $event" @change="uploadFile" @clearUpload="clearFile"
                      :modelProp="getAttachModelPropName(attach)"
                      :state="ModelProcedure.Resident[idx][getAttachModelPropName(attach)]" :invalid="submitted &&
                        $v.ModelProcedure.Resident.$each[idx][getAttachModelPropName(attach)] &&
                        $v.ModelProcedure.Resident.$each[idx][getAttachModelPropName(attach)].$invalid
                        " :previewURL="getAttachPreviewURL(attach, ModelProcedure.Resident[idx])" style="z-index: 1" />
                  </template>
                </div>
                <div v-if="showTooltipActive === 'ProcedureResidentAttachment.IdFacialRecognition'"
                  class="empadronamiento__intro__main__form__tooltip-file">
                </div>


                <base-input placeholder="Dirección legal *" v-model="ModelProcedure.Resident[idx].PreviousAddres"
                  :invalid="$v.ModelProcedure.Resident.$each[idx].PreviousAddres
                    .$invalid && submitted
                    " />

                <base-input type="email" placeholder="Mail del nuevo residente *"
                  v-model="ModelProcedure.Resident[idx].Email" :invalid="$v.ModelProcedure.Resident.$each[idx].Email.$invalid &&
                    submitted
                    " />

                <base-input type="tel" placeholder="Teléfono de contacto *"
                  v-model="ModelProcedure.Resident[idx].ContactPhone" :invalid="$v.ModelProcedure.Resident.$each[idx].ContactPhone
                    .$invalid && submitted
                    " />

                <base-input v-if="validateAgeForSchool(ModelProcedure.Resident[idx])" placeholder="Colegio"
                  v-model="ModelProcedure.Resident[idx].School" />
              </fieldset>
            </template>
          </fieldset>
          <base-add-section v-if="hasResident" label="Agregar residente" @click="addResident" />
        </form>

        <div class="empadronamiento__intro__button">
          <button-link back>
            <p>Volver</p>
          </button-link>

          <button v-if="!loadingForm" class="active" @click="sendResidents()">
            Guardar
          </button>

          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
    <div v-if="showTooltipActive != ''" class="tooltip-background" @click="showTooltipActive = ''"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { required, not } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  data() {
    return {
      ownerSpouse: false,
      hasResident: false,
      loading: true,
      //ownerSpouseId: 0,
      submitted: false,
      section: "RESIDENT",
      loadingForm: false,
      showTooltipActive: "",
      viewKey: new Date().getTime(),
    };
  },
  computed: {
    ...mapState({
      Enums: (state) => state.neighregistration.Enums,
      ModelProcedure: (state) => state.manageVecino.ModelProcedure,
    }),
    ...mapGetters(["findAttachPropByName"]),
    DateOfBirthMaxDate() {
      return moment(new Date()).format("DD/MM/YYYY");
    },
    sortedResidentAttachTypes() {
      const types = this.Enums && this.Enums.ProcedureResidentAttachType
        ? this.Enums.ProcedureResidentAttachType.slice()
        : [];

      const isFacial = (code) =>
        code === "IdFacialRecognition" ||
        code === "ProcedureResidentAttachment.IdFacialRecognition";

      return types.sort((a, b) => {
        const aIsFacial = isFacial(a.Code);
        const bIsFacial = isFacial(b.Code);

        if (aIsFacial && !bIsFacial) return -1;
        if (!aIsFacial && bIsFacial) return 1;
        return 0;
      });
    },

  },
  // eslint-disable-next-line no-console

  mounted() {
    const self = this;
    if (!this.ModelProcedure.hasOwnProperty("UCode")) {
      this.$store
        .dispatch("getProcedure", {
          ucode: this.$route.query.ucode,
        })
        .then(() => {
          this.$store.dispatch("getEnums");
          this.hasResident = this.ModelProcedure.Resident.length > 0;
          self.loading = false;
        });
    } else {
      this.$store.dispatch("getEnums");
      this.hasResident = this.ModelProcedure.Resident.length > 0;
      self.loading = false;
    }
  },

  methods: {
    onCivilStatusClick(idx, maritalId) {
      this.ModelProcedure.Resident[idx].MaritalStatusId = maritalId;
      this.$forceUpdate();
      //this.viewKey = new Date().getTime();
    },
    validateAgeForSchool(residente) {
      var totalMonths = moment().diff(
        moment(residente.DateOfBirth, "DD/MM/YYYY").format("YYYY-MM-DD"),
        "months"
      );
      var totalYears = parseInt(totalMonths / 12);
      return totalYears <= 18;
    },

    getAttachPreviewURL(attach, resident) {
      let attachId = null;
      let attachUrl = "";
      attachId = resident[this.getAttachModelPropName(attach)];
      if (attachId != null) {
        attachUrl = `${process.env.VUE_APP_URL_API
          }/neighregistration/procedureresidentattachment/preview/${attachId}`;
      }
      return attachUrl;
    },

    addResident() {
      this.$store.dispatch("addResident").then(() => {
        const idx = this.ModelProcedure.Resident.length - 1;
        const r = this.ModelProcedure.Resident[idx];
        const attachTypes = this.Enums && this.Enums.ProcedureResidentAttachType;
        if (!attachTypes) return; // enums aun no cargados
        const attachProps = attachTypes.map(a => this.getAttachModelPropName(a));
        attachProps.forEach(p => {
          if (r[p] === undefined || r[p] === null) r[p] = 0;
        });
      });
    },

    deleteResident(index) {
      this.$store.dispatch("removeResident", index);
    },

    sendResidents() {
      const self = this;
      self.submitted = true;

      if (this.$v && this.$v.$touch) this.$v.$touch();

      if (!this.hasResident) {
        self.ModelProcedure.Resident = [];
      }

      const invalid = this.isInvalidForm();

      if (!invalid) {

        self.ModelProcedure.Resident.forEach((resident) => {
          if (resident.IdFacialRecognition !== 0) {
            self.ModelProcedure.HasFacialRecognitionFile = true;
            self.ModelProcedure.ResidentIdentificationTypeId =
              resident.IdentificationTypeId || null;
            self.ModelProcedure.ResidentIdentification =
              resident.Identification || "";
          }
        });

        self.loadingForm = true;
        self.$store
          .dispatch("updateProcedure", { model: self.ModelProcedure })
          .then(() => {
            self.loadingForm = false;

            const existNoResident = self.ModelProcedure.Titulars.some(
              (r) => !r.IsResident
            );
            const nextPath = !existNoResident
              ? `/vecino/terminos-y-condiciones?ucode=${self.$route.query.ucode}`
              : `/vecino/vehiculos?ucode=${self.$route.query.ucode}`;

            self.$router.push(nextPath);
          });
      } else {
        const element = document.querySelector(
          ".empadronamiento__intro__main__form__container-item .has-error"
        );
        if (element != null)
          element.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    },
    /*
    changeOwnerSpouse() {
      this.$store.dispatch("updateResident", {
        ownerSpouseId: this.ownerSpouseId,
      });
    },
    */
    getAttachModelPropName(attach) {
      const returnValue = this.$store.getters.findAttachPropByName(
        attach.Name,
        this.section
      );

      return returnValue;
    },

    uploadFile({ file, attachmentTypeId, modelProp, keyIndex }) {
      const resident = this.ModelProcedure.Resident[keyIndex];
      if (!resident) return;

      const attach = this.Enums.ProcedureResidentAttachType.find(
        a => this.getAttachModelPropName(a) === modelProp
      );

      if (attach && attach.Code === "ProcedureResidentAttachment.IdFacialRecognition") {
        const validExtensions = ["jpg", "jpeg", "png"];
        const ext = file.name.split(".").pop().toLowerCase();
        if (!validExtensions.includes(ext)) {
          window.mainApp.$store.dispatch(
            "addNotification",
            "Formato no permitido. Las extensiones permitidas son: jpg, jpeg, png."
          );
          return;
        }

        // Validación de tamaño
        if (file.size > 10 * 1024 * 1024) {
          window.mainApp.$store.dispatch(
            "addNotification",
            "El archivo es demasiado pesado. Máximo 10MB."
          );
          return;
        }

        // Validación de dimensiones
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            if (img.width < 250 || img.height < 250) {
              window.mainApp.$store.dispatch(
                "addNotification",
                "La imagen debe tener un tamaño mínimo de 250 x 250px."
              );
              return;
            }
            this.$store.dispatch("uploadFile", { file, attachmentTypeId, section: "RESIDENT" })
              .then(res => {
                resident[modelProp] = res;
                this.ModelProcedure.HasFacialRecognitionFile = true;
              });
          };
        };
      } else {
        // Archivos normales
        this.$store.dispatch("uploadFile", { file, attachmentTypeId, section: "RESIDENT" })
          .then(res => resident[modelProp] = res);
      }
    },

    clearFile({ modelProp, keyIndex }) {
      const self = this;
      self.ModelProcedure.Resident[keyIndex][modelProp] = 0;
    },

    isInvalidForm() {
      let invalid;
      let model = this.$v.ModelProcedure.Resident.$model;
      if (this.hasResident) {
        if (this.validateRecurrenceCertificates(model)) {
          invalid = true;
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn('[Resident] blocked by validateRecurrenceCertificates');
          }
        } else {
          invalid = this.$v.ModelProcedure.Resident.$invalid;

          // log campos invalidos por residente
          if (invalid && process.env.NODE_ENV !== 'production') {
            this.$v.ModelProcedure.Resident.$each.$iter &&
              Object.entries(this.$v.ModelProcedure.Resident.$each.$iter).forEach(([idx, v]) => {
                if (v.$invalid) {
                  const failedFields = Object.keys(v).filter(
                    k => !k.startsWith('$') && v[k] && v[k].$invalid
                  );
                  // eslint-disable-next-line no-console
                  console.warn(`[Resident] idx=${idx} IsResident=${this.ModelProcedure.Resident[idx].IsResident} campos invalidos:`, failedFields);
                }
              });
          }

          if (!invalid) {
            this.ModelProcedure.Resident.forEach((r) => {
              invalid = r.IdRecurrence === 0 && r.IsResident === false;
              if (invalid && process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.warn('[Resident] blocked by IdRecurrence=0 and IsResident=false name:', r.Name);
              }
            });
          }
        }
      } else {
        invalid = false;
      }
      return invalid;
    },

    validateAge(birthDate) {
      const formattedDate = moment(birthDate, "DD/MM/YYYY");
      const today = moment();
      const age = today.diff(formattedDate, "years");

      return age;
    },

    validateRecurrenceCertificate(resident) {
      const age = this.validateAge(resident.DateOfBirth);
      if (isNaN(age)) return true; // fecha invalida, no bloquear
      const valid =
        age < 18 ||
        (age >= 18 && resident.IdRecurrence !== 0 && !resident.IsResident) ||
        (age >= 18 && resident.IdRecurrence === 0 && resident.IsResident);
      return valid;
    },

    validateRecurrenceCertificates(residents) {
      return residents.some((resident) => {
        const age = this.validateAge(resident.DateOfBirth);
        if (isNaN(age)) return false; // fecha invalida, no bloquear
        const valid =
          age < 18 ||
          (age >= 18 && resident.IdRecurrence !== 0 && !resident.IsResident) ||
          (age >= 18 && resident.IdRecurrence === 0 && resident.IsResident);
        return !valid;
      });
    },
    normalizeDni(v) {
      return String(v || "").replace(/\D/g, "");
    },
    isDNIResident(identificationTypeId) {
      const types = this.Enums && this.Enums.IdentificationType;
      if (!types || !identificationTypeId) return true;
      const found = types.find(t => t.Id == identificationTypeId);
      return !found || found.Code === 'DNI' || found.Name === 'DNI';
    },
    normalizeResidentDoc(val, identificationTypeId) {
      if (this.isDNIResident(identificationTypeId)) {
        return val.replace(/\D/g, '');
      }
      return val.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    },
    docFormatErrorResident(val, identificationTypeId) {
      if (!val) return null;
      if (this.isDNIResident(identificationTypeId)) {
        return /^\d{7,8}$/.test(val) ? null : 'El DNI debe contener entre 7 y 8 digitos.';
      }
      return /^[A-Z]{1,3}[0-9]{6,}$/.test(val) ? null : 'El pasaporte debe comenzar con 1 a 3 letras seguidas de numeros. Ej: AA123456';
    },
    isDuplicateResident(typeId, dni, idxActual) {
      const dniNorm = this.normalizeDni(dni);
      return this.ModelProcedure.Resident.some((r, i) => {
        if (i === idxActual) return false;
        return (
          String(r.IdentificationTypeId) === String(typeId) &&
          this.normalizeDni(r.Identification) === dniNorm
        );
      });
    },

    onDocTypeChange(idx) {
      const r = this.ModelProcedure.Resident[idx];
      if (r && r.Identification) {
        this.triggerResidentLookup(idx);
      }
    },
    isSameAsTitular(typeId, dni) {
      const dniNorm = this.normalizeDni(dni);
      const titulars = (this.ModelProcedure && this.ModelProcedure.Titulars) || [];
      return titulars.some(t =>
        String(t.IdentificationTypeId) === String(typeId) &&
        this.normalizeDni(t.Identification) === dniNorm
      );
    },

    triggerResidentLookup(idx) {
      const resident = this.ModelProcedure.Resident[idx];
      const typeId = resident && resident.IdentificationTypeId;
      const dni = resident && resident.Identification;
      if (!typeId || !dni) return;

      if (this.isSameAsTitular(typeId, dni)) {
        this.$v.ModelProcedure.Resident.$each[idx].Identification.$touch();
        window.mainApp.$store.dispatch(
          "addNotification",
          "El DNI del residente no puede ser el mismo que el del titular propietario."
        );
        this.ModelProcedure.Resident[idx].Identification = "";
        return;
      }

      if (this.isDuplicateResident(typeId, dni, idx)) {
        this.$v.ModelProcedure.Resident.$each[idx].Identification.$touch();
        window.mainApp.$store.dispatch(
          "addNotification",
          "Ese residente ya fue agregado. Ingrese un nuevo DNI."
        );
        this.ModelProcedure.Resident[idx].Identification = "";
        return;
      }
      this.$store
        .dispatch("getResidentByDni", {
          typeId,
          identification: dni,
          idx,
        })
        .then(() => {
          this.$forceUpdate();
        });
    },
    hideAttachments(idx) {
      return (
        this.ModelProcedure &&
        this.ModelProcedure.Resident[idx].IsResident === true
      );
    },
  },
  watch: {
    hasResident(value) {
      if (!value) this.ModelProcedure.Resident = [];
      else if (this.ModelProcedure.Resident.length === 0) this.addResident();
    },
  },
  validations: {
    ModelProcedure: {
      Resident: {
        $each: {
          Name: {
            required,
          },
          LastName: {
            required,
          },
          DateOfBirth: {
            required,
          },
          IdentificationTypeId: {
            required,
            not: not((model) => model === 0),
          },
          Identification: {
            required,
          },
          ResidentTypeId: {
            required,
            not: not((model) => model === 0),
          },
          PreviousAddres: {
            required,
          },
          Email: {
            required,
          },
          ContactPhone: {
            required,
          },
          IdFront: {
            validIfNeeded: (val, parent) => parent.IsResident || val !== 0,
          },
          IdBack: {
            validIfNeeded: (val, parent) => parent.IsResident || val !== 0,
          },
          IdFacialRecognition: {
            validIfNeeded: (val, parent) => parent.IsResident || val !== 0,
          },
          IdRecurrence: {
            validIfNeeded: (val, parent) => parent.IsResident || val !== 0,
          },
          IdResidence: {
            validIfNeeded: (val, parent) => parent.IsResident || val !== 0,
          },
          MaritalStatusId: {
            required,
            not: not((model) => model === 0),
          },
        },
      },
    },
  },
};
</script>
